import { render, staticRenderFns } from "./crm-create_citizenship.vue?vue&type=template&id=1528fbcd&"
import script from "./crm-create_citizenship.vue?vue&type=script&lang=js&"
export * from "./crm-create_citizenship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports